export const experience = [
    {
      id: '01',
      role: 'Software Engineer',
      company: 'iConsult Collaborative',
      location: 'Syracuse, NY',
      period: 'Feb 2025 – Present',
      bullets: [
        'Startup client (AI-powered Excel automation platform): Built a desktop automation platform (Electron, React, Node.js) that replaced manual Excel workflows with a unified UI for discovering and executing VBA macros, reducing analyst task completion time by 25%.',
        'Designed COM-based Excel integration and Electron IPC pipelines to dynamically extract workbook metadata and trigger macro execution, reducing manual lookup time by 40%.',
        'Engineered modular backend services (FastAPI, PostgreSQL, Docker) for macro orchestration and user-defined automation workflows, maintaining stable response times during peak usage.',
        'Startup client (mobile networking platform): Engineered a cross-platform React Native app (TypeScript, JWT, REST APIs) delivering a production-ready MVP for iOS and Android.',
        'Built real-time swipe-based matching and gesture-driven UI flows, reducing state reload failures by 30% and cutting average interaction response time by 45%.',
        'Designed persistent session management and optimized UI performance with AsyncStorage and animation pipelines, reducing average screen load time by 60%.'
        ],
    },
    {
      id: '02',
      role: 'Software Engineering Intern',
      company: 'D&D Motor Systems, Inc.',
      location: 'Syracuse, NY',
      period: 'May 2025 – Aug 2025',
      bullets: [
        'Led migration of a 20+ page legacy PHP platform to a scalable React + Next.js micro-frontend architecture, reducing page load time by 40% and improving maintainability.',
        'Designed and deployed cloud infrastructure on AWS (ECS, S3, CloudFront) with Docker and CI/CD pipelines, enabling zero-downtime releases and improving deployment reliability.',
        'Built a real-time analytics dashboard (Node.js, PostgreSQL) used by business teams to track conversion and revenue metrics, driving data-informed decision making.',
        'Developed an AI-powered customer support assistant using OpenAI APIs and vector search, increasing qualified lead conversions by 25%.'
      ],
    },
  ];